import React from 'react';
import './ChatHeader.css';

const ChatHeader = ({ onClose, onRefresh, onMaximize, isMaximized }) => {
  return (
    <div className="chat-header">
      <div className="chat-header-content">
        <div className="chat-header-icon">
          <svg width="48" height="48" viewBox="0 0 48 48" fill="none">
            <circle cx="24" cy="24" r="24" fill="#1DB9AA"/>
            <path d="M24 14C24 14 20 14 17 17C14 20 14 24 14 24V30C14 30 14 32 16 32H32C32 32 34 32 34 30V24C34 24 34 20 31 17C28 14 24 14 24 14Z" fill="white"/>
            <rect x="20" y="26" width="8" height="2" fill="#1DB9AA"/>
            <circle cx="20" cy="22" r="1.5" fill="#1DB9AA"/>
            <circle cx="28" cy="22" r="1.5" fill="#1DB9AA"/>
          </svg>
        </div>
        <div className="chat-header-text">
          <h3>EnterOne Assistant</h3>
          <p>Always here to help</p>
        </div>
      </div>
      <div className="chat-header-actions">
        <button 
          className="chat-action-btn refresh-btn"
          onClick={onRefresh}
          aria-label="Refresh chat"
          title="Refresh chat history"
        >
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
          </svg>
        </button>
        {/* <button 
          className="chat-action-btn fullscreen-btn"
          onClick={onMaximize}
          aria-label={isMaximized ? "Minimize" : "Maximize"}
          title={isMaximized ? "Minimize chat" : "Maximize chat"}
        >
          {isMaximized ? (
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M9 9V4.5M9 9H4.5M9 9L3.5 3.5M15 9v4.5M15 9h4.5M15 9l5.5-5.5M9 15v4.5M9 15H4.5M9 15l-5.5 5.5M15 15v-4.5M15 15h4.5M15 15l5.5 5.5" />
            </svg>
          ) : (
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M4 8V4m0 0h4M4 4l5 5m11-1V4m0 0h-4m4 0l-5 5M4 16v4m0 0h4m-4 0l5-5m11 5l-5-5m5 5v-4m0 4h-4" />
            </svg>
          )}
        </button> */}
        <button 
          className="chat-action-btn close-btn"
          onClick={onClose}
          aria-label="Close"
          title="Close chat"
        >
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 4l8 8M4 12l8-8" />
          </svg>
        </button>
      </div>
    </div>
  );
};

export default ChatHeader;

